import { useState } from "react";

import { useDispatch, useSelector } from "react-redux";

import { HiOutlineComputerDesktop } from "react-icons/hi2";

import SettingsCard from "./SettingsCard";
import ConfirmModal from "../../../../components/ui/confirmModal/ConfirmModal";

import {
  getSessions,
  revokeAllSessions,
  revokeSession,
} from "../../../../redux/features/settings/settingsSlice";

import "./SessionsCard.css";

const formatDate = (value) => {
  if (!value) return "-";

  const date = new Date(value);

  if (Number.isNaN(date.getTime())) return "-";

  return date.toLocaleString("nl-BE");
};

export default function SessionsCard() {
  const dispatch = useDispatch();

  const { sessions, isLoadingSessions, isRevokingSession } = useSelector(
    (state) => state.settings,
  );

  const [confirmModal, setConfirmModal] = useState({
    isOpen: false,
    title: "",
    message: "",
    confirmText: "Bevestigen",
    variant: "danger",
    onConfirm: null,
  });

  const closeConfirm = () => {
    setConfirmModal({
      isOpen: false,
      title: "",
      message: "",
      confirmText: "Bevestigen",
      variant: "danger",
      onConfirm: null,
    });
  };

  const handleRevokeSession = (session) => {
    setConfirmModal({
      isOpen: true,
      title: "Sessie intrekken?",
      message: "Deze sessie wordt onmiddellijk ongeldig gemaakt.",
      confirmText: "Intrekken",
      variant: "danger",
      onConfirm: async () => {
        await dispatch(revokeSession(session._id)).unwrap();
        closeConfirm();
      },
    });
  };

  const handleRevokeAll = () => {
    setConfirmModal({
      isOpen: true,
      title: "Alle sessies intrekken?",
      message:
        "Alle actieve sessies worden ingetrokken. Mogelijk moet je opnieuw inloggen.",
      confirmText: "Alles intrekken",
      variant: "danger",
      onConfirm: async () => {
        await dispatch(revokeAllSessions()).unwrap();
        closeConfirm();
        dispatch(getSessions());
      },
    });
  };

  return (
    <SettingsCard
      icon={<HiOutlineComputerDesktop />}
      title="Sessies"
      description="Bekijk en beheer actieve sessies."
    >
      <div className="sessions-card__top">
        <span>{sessions.length} sessies</span>

        <button
          type="button"
          className="sessions-card__danger"
          disabled={isRevokingSession || sessions.length === 0}
          onClick={handleRevokeAll}
        >
          Alle sessies intrekken
        </button>
      </div>

      {isLoadingSessions ? (
        <div className="sessions-card__loading">Sessies laden...</div>
      ) : sessions.length === 0 ? (
        <div className="sessions-card__empty">Geen actieve sessies.</div>
      ) : (
        <div className="sessions-card__list">
          {sessions.map((session) => (
            <div key={session._id} className="sessions-card__item">
              <div>
                <strong>{session.ip_address || "Onbekend IP"}</strong>

                <span>{session.user_agent || "Onbekende browser"}</span>

                <small>
                  Laatst gebruikt: {formatDate(session.last_used_at)}
                </small>

                <small>Verloopt: {formatDate(session.expires_at)}</small>
              </div>

              <button
                type="button"
                disabled={isRevokingSession || session.revoked_at}
                onClick={() => handleRevokeSession(session)}
              >
                Intrekken
              </button>
            </div>
          ))}
        </div>
      )}

      <ConfirmModal
        isOpen={confirmModal.isOpen}
        title={confirmModal.title}
        message={confirmModal.message}
        confirmText={confirmModal.confirmText}
        variant={confirmModal.variant}
        onClose={closeConfirm}
        onConfirm={confirmModal.onConfirm}
      />
    </SettingsCard>
  );
}
